module.exports = __webpack_public_path__ + "e1ba2666aa891c8824eacdd95559ec4d.svg";